module.exports = "/images/animal-borne-disease@3x.png?a365ee810be173d01cec763e018bd816";